var site = site || {};

(function ($) {
  Drupal.behaviors.skinRhythmSkinDamageV1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var $thismodule = $('.js-skinrhythm-skindamage', context);
      var $breadcrumbs = $thismodule.find('.js-skinrhythm-skindamage__breadcrumbs').children();

      function fireAnalytic(eventAction, eventLabel) {
        if (site && site.track) {
          site.track.evtLink({
            event_name: 'elSkinRhythm',
            event_category: 'skin rhythm skin damage carousel',
            event_action: eventAction,
            event_label: eventLabel
          });
        }
      }

      if ($breadcrumbs.length > 0 && !isMobile()) {
        $.each($breadcrumbs, function (bc_index, bc_value) {
          var $bc = $(bc_value);

          if (bc_index === 0) {
            $bc.addClass('active');
          }
          if (bc_index !== $breadcrumbs.length - 1) {
            $('<p class="divider">|</p>').insertAfter($bc);
          }
          $.event.trigger({
            type: 'basic_carousel_formatter:move_to_slide',
            payload: 0
          });
        });
        $breadcrumbs.once().on('click', function () {
          $breadcrumbs.removeClass('active');
          var $this = $(this);

          $this.addClass('active');
          var index = $breadcrumbs.index($this);

          $.event.trigger({
            type: 'basic_carousel_formatter:move_to_slide',
            payload: index
          });
          fireAnalytic('carousel slide number: ' + index, $this.html());
        });
      }

      function isMobile() {
        return Unison.fetch.now().name === 'small';
      }
    }
  };
})(jQuery);
